import React, { Fragment } from 'react';

import {
  FetchLifestylesCacheKeys,
  UpdateLifestyleCacheAction
} from '../../../../../../lifestyles/lifestylesTypes';
import {
  UpdateLifestylesSetCacheAction,
  FetchLifestylesSetsCacheKeys
} from '../../../../../../lifestylesSets/lifestylesSetsTypes';
import {
  ThreeDStockLifestylesListLightboxBottomButtonsLifestyle,
  ThreeDStockLifestylesListLightboxBottomButtonsLifestylesSet
} from './ThreeDStockLifestylesListLightboxBottomButtons.types';

import { ThreeDStockLifestylesListLightboxSelectButton } from '../ThreeDStockLifestylesListLightboxSelectButton';

interface ThreeDStockLifestylesListLightboxBottomButtonsDefaultProps {
  lifestyle: ThreeDStockLifestylesListLightboxBottomButtonsLifestyle;
  lifestylesCacheKeys?: FetchLifestylesCacheKeys;
  updateLifestyleCache?: UpdateLifestyleCacheAction<ThreeDStockLifestylesListLightboxBottomButtonsLifestyle>;
}

interface ThreeDStockLifestylesListLightboxBottomButtonsWithSelectProps {
  lifestylesSet: ThreeDStockLifestylesListLightboxBottomButtonsLifestylesSet | null;
  lifestylesSetCacheKeys?: FetchLifestylesSetsCacheKeys;
  updateLifestylesSetCache: UpdateLifestylesSetCacheAction<ThreeDStockLifestylesListLightboxBottomButtonsLifestylesSet>;
}

interface ThreeDStockLifestylesListLightboxBottomButtonsWithoutProps {
  lifestylesSet?: never;
  lifestylesSetCacheKeys?: never;
  updateLifestylesSetCache?: never;
}

type ThreeDStockLifestylesListLightboxBottomButtonsProps =
  ThreeDStockLifestylesListLightboxBottomButtonsDefaultProps &
    (
      | ThreeDStockLifestylesListLightboxBottomButtonsWithSelectProps
      | ThreeDStockLifestylesListLightboxBottomButtonsWithoutProps
    );

function ThreeDStockLifestylesListLightboxBottomButtons({
  lifestyle,
  lifestylesSet,
  lifestylesSetCacheKeys,
  updateLifestylesSetCache
}: ThreeDStockLifestylesListLightboxBottomButtonsProps) {
  return (
    <Fragment>
      <ThreeDStockLifestylesListLightboxSelectButton
        lifestyle={lifestyle}
        lifestylesSet={lifestylesSet}
        lifestylesSetCacheKeys={lifestylesSetCacheKeys}
        updateLifestylesSetCache={updateLifestylesSetCache}
      />
    </Fragment>
  );
}

export default ThreeDStockLifestylesListLightboxBottomButtons;
